//
//
//
//
//
//
//
//
//
//

import Loader from '@/filterCards/components/Loader'
import Error from '@/filterCards/components/Error'
import Filters from '@/filterCards/components/Filters'
import Grid from '@/filterCards/components/Grid'

import {mapGetters, mapMutations, mapActions} from 'vuex'

export default {
	name: 'FilterCards',
	props: ['id', 'layout', 'practiceGroups', 'taskForces', 'businessCategories', 'contentTypes', 'topics', 'showContentTypesFilter', 'startDate', 'endDate', 'topicFilters','sortOrder'],
	components: {
		appLoader: Loader,
		appError: Error,
		appFilters: Filters,
		appGrid: Grid
	},
	data() {
		return {}
	},
	computed: {
		...mapGetters(["status", "can_load_more"])
	},
	methods: {
		...mapMutations(['set_id', 'set_layout', 'set_contentTypes', 'set_topics', 'set_businessCategories', 'set_practiceGroups', 'set_taskForces', 'set_startDate', 'set_endDate', 'set_topicFilters', 'set_sortOrder']),
		...mapActions(["initialize", "load_more"]),
		more() {
			this.load_more(this.id)
		}
	},
	async created() {
		this.set_id(this.id)
		this.set_layout(this.layout)

		if(this.contentTypes)
			this.set_contentTypes(this.contentTypes);
		if(this.topics)
			this.set_topics(this.topics);
		if(this.businessCategories)
			this.set_businessCategories(this.businessCategories);
		if(this.practiceGroups)
			this.set_practiceGroups(this.practiceGroups);
		if(this.taskForces)
			this.set_taskForces(this.taskForces);
		if (this.startDate)
			this.set_startDate(this.startDate);
		if (this.endDate)
			this.set_endDate(this.endDate);
		if (this.topicFilters)
			this.set_topicFilters(this.topicFilters);
		if (this.sortOrder)
			this.set_sortOrder(this.sortOrder);	

		await this.initialize();
	}
}
